import { Button, Flex, Icon, Stack, Text } from "@chakra-ui/react"
import { RiCloseCircleLine, RiFocus3Line } from "react-icons/ri";

import { useCart } from "../../hooks/cart";

type IndicadorData = {
	id: string;
	nome: string;
	cid: string
	doc: string;
	phone: string;
	comissao: number;
}
interface IndicadorParams {
	setIsOpenModalIndicadores: (open: boolean) => void;
}

const Indicador: React.FC<IndicadorParams> = ({ setIsOpenModalIndicadores }) => {
	const { cart, addCartIndicador } = useCart();

	return (
		<Flex flexDir="column" mt="6">
			<Stack direction="row" spacing="4">
				<Text
					as="button"
					fontSize={["18", "20"]}
					fontWeight="500"
					color="blue.100"
					pb="2"
					textTransform="capitalize"
					borderBottomWidth={2}
					borderBottomColor="blue.100"
					onClick={() => {}}
				>
					{cart.operacao.indicador_desc}
				</Text>
			</Stack>

			<Flex pt="4" justify="space-between">
				<Flex>
					<Flex
						w="50px"
						h="50px"
						bg="gray.100"
						justify="center"
						align="center"
						borderRadius={8}
					>
						<Icon as={RiFocus3Line} fontSize={24} />
					</Flex>

					<Flex
						flexDir="column"
						ml="4"
					>
						<Text fontSize={["16", "18"]} fontWeight="500" color="gray.900">
							{cart.indicador && cart.indicador.id
								? (
									<>
										{cart.indicador.nome}
										<Button
											p={0}
											size="sm"
											bg="transparent"
											_hover={{ bg: 'transparent' }}
											onClick={() => addCartIndicador({} as IndicadorData)}
										>
											<Icon as={RiCloseCircleLine} fontSize="20" color="red.300" />
										</Button>
									</>
								) : "Nenhum indicador"}
						</Text>

						<Text fontSize={["13", "14"]} fontWeight="500" color="gray.500">
							{cart.indicador && cart.indicador.id 
								? `${cart.indicador.doc && `${cart.indicador.doc} - `}${cart.indicador.phone}` 
								: 'Selecione um indicador'}
						</Text>
					</Flex>
				</Flex>

				<Flex>
					<Text
						as="button"
						color="blue.100"
						fontSize={["14", "18"]}
						fontWeight={["600", "500"]}
						onClick={() => setIsOpenModalIndicadores(true)}
					>
						{cart.indicador && cart.indicador.id ? "Trocar" : "Selecionar"}
					</Text>
				</Flex>
			</Flex>
		</Flex>
	)
}

export default Indicador;